import {CustomerActions, CustomerActionTypes} from './customer.actions';
import { SapAddress } from 'libs/sap/src/lib/models/sap.model';


export interface CustomerState {
	billingAddresses: SapAddress[],
	shippingAddresses: SapAddress[]
}

export const initialCustomerState: CustomerState = {
	billingAddresses: [],
	shippingAddresses: [],
};

export function reducer(state = initialCustomerState, action: CustomerActions): CustomerState {
	switch (action.type) {
		case CustomerActionTypes.AddressesLoaded:
			return {
				...state,
				billingAddresses: action.payload.billingAddresses,
				shippingAddresses: action.payload.shippingAddresses
			};

		default:
			return state;
	}
}
